import { connect } from 'react-redux';
import { TripType } from '@eti/schema-types';
import { change } from 'redux-form';
import { AirportAvailability } from '@eti/components';
import { useState } from 'react';
import { price as priceUtils } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import { validateLoungeAvailabilityTranslation } from '../utils';
import { getUpsellProps, parseJsonProp } from '../../common/utils/productCardProps';
import { AvailabilityType, getAvailabilityList, getCartAvailability } from '../../common/utils/availability';
import { ProductCardLayoutType } from '../../common/models/product';
import { getSelected } from '../../single-choice/utils/selection';
import { LOUNGE } from '../../products';
import { useProductData } from '../../common/hook/useProductData';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { availablityProductCardGrid, availabilityReadMoreGrid } from '../../common/utils/styles';
import { getPriceDivided } from '../../common/utils/price';
import LoungeDrawer from './LoungeDrawer';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = LOUNGE;
const Lounge = _ref => {
  var _productSegmentAvaila, _order$travelers$leng, _order$travelers2;
  let {
    className,
    form,
    isSelected,
    order,
    productSpecificTexts,
    productPosition,
    dispatch,
    tripType,
    layoutType = ProductCardLayoutType.Main
  } = _ref;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [lounge, setLounge] = useState();
  const {
    t
  } = useTranslation();
  const texts = {
    additionalInformation: 'loungeAdditionalInformation',
    abstractContent: 'loungeAbstract',
    readMoreContent: 'loungeReadMoreModalContent',
    title: 'loungeTitle',
    upSell: 'loungeUpSellText',
    airportAvailability: 'loungeGeneralPurpose'
  };
  const isMultiStop = tripType !== TripType.OneWay && tripType !== TripType.Return;
  const openDrawer = airport => {
    if (airport.loungeInfo) {
      setLounge(airport.loungeInfo);
    }
    setIsDrawerOpen(true);
  };
  const {
    rootElement,
    productData,
    translation: {
      airportAvailability,
      upSell
    }
  } = useProductData({
    className,
    form,
    isSelected,
    layoutType,
    order,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productPosition,
    texts
  });
  if (!productData) {
    return null;
  }
  const availabilityList = getAvailabilityList(order.bounds, (_productSegmentAvaila = productSpecificTexts.productSegmentAvailabilityTexts) !== null && _productSegmentAvaila !== void 0 ? _productSegmentAvaila : [], AvailabilityType.PerSegment);
  const availabilityProps = parseJsonProp(airportAvailability);
  const hasAllTranslation = validateLoungeAvailabilityTranslation(availabilityProps);
  const shouldDisplayAvailability = availabilityList && availabilityList.length > 0 && hasAllTranslation;
  const handleAvailabilitySelection = value => {
    if (!dispatch) {
      return;
    }
    if (value === 'true' && shouldDisplayAvailability) {
      var _order$travelers;
      dispatch(change(form, `${PRODUCT_NAME}.cartBreakDown`, getCartAvailability(order === null || order === void 0 || (_order$travelers = order.travelers) === null || _order$travelers === void 0 ? void 0 : _order$travelers.length, availabilityProps === null || availabilityProps === void 0 ? void 0 : availabilityProps.cart.purchasedMessage, availabilityList)));
    }
  };
  const {
    upSellObject,
    isUpsellHighlight = false,
    shouldDisplayUpsell = false
  } = getUpsellProps(upSell, {
    shouldDisplayAvailability,
    availabilityList,
    tripType
  });
  const updatedExtraProps = {
    ...(productData === null || productData === void 0 ? void 0 : productData.extraProps),
    availabilityList,
    availabilityTranslation: availabilityProps,
    onButtonChange: handleAvailabilitySelection
  };
  const numberOfTravelers = (_order$travelers$leng = order === null || order === void 0 || (_order$travelers2 = order.travelers) === null || _order$travelers2 === void 0 ? void 0 : _order$travelers2.length) !== null && _order$travelers$leng !== void 0 ? _order$travelers$leng : 1;
  const price = priceUtils.formatPrice(getPriceDivided(productData.priceRaw, numberOfTravelers));
  const perTravelerLabel = t('Product.Price.Per.Person');
  const updatedProductData = {
    ...productData,
    ...(!isSelected && {
      price,
      priceSuffix: perTravelerLabel
    }),
    extraProps: updatedExtraProps,
    upSell: upSellObject,
    isHighlighted: isUpsellHighlight,
    shouldDisplayUpsell
  };
  return /*#__PURE__*/_jsxs(ProductLayout, {
    productData: updatedProductData,
    ref: rootElement,
    children: [shouldDisplayAvailability && /*#__PURE__*/_jsx(ProductLayout.ReadMore, {
      customGrid: availabilityReadMoreGrid,
      children: /*#__PURE__*/_jsx(AirportAvailability, {
        isDrawerOpen: isDrawerOpen,
        isMultiStop: isMultiStop,
        openDrawer: openDrawer,
        productData: updatedProductData,
        testid: "availability-readmore"
      })
    }), isSelected && shouldDisplayAvailability && /*#__PURE__*/_jsx(AirportAvailability, {
      className: availablityProductCardGrid,
      isDrawerOpen: isDrawerOpen,
      isMultiStop: isMultiStop,
      isSelected: isSelected,
      openDrawer: openDrawer,
      productData: updatedProductData,
      testid: "availability-purchase"
    }), /*#__PURE__*/_jsx(LoungeDrawer, {
      drawerText: availabilityProps === null || availabilityProps === void 0 ? void 0 : availabilityProps.drawer,
      isOpen: isDrawerOpen,
      loungeInfo: lounge,
      setOpen: setIsDrawerOpen
    })]
  });
};
const mapStateToProps = (state, _ref2) => {
  let {
    form
  } = _ref2;
  return {
    isSelected: getSelected(LOUNGE.name, form)(state)
  };
};
export default connect(mapStateToProps)(Lounge);
//# sourceMappingURL=Lounge.js.map